import { finance } from "../data";
import { createButton } from "./createButton";
/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.GameObjects.Image} pause
 * @param {Phaser.Physics.Arcade.Sprite} character
 */
export const win = (
  scene,
  character,
  pause,
  width,
  height,
  scaleX,
  callbackText,
  callbackFinal
) => {
  pause.setVisible(false);
  scene.sound.play("win");
  if (finance.skinned) {
    character.play("skinnedWin");
  } else {
    character.play("win");
  }
  finance.level++;
  /**
   * @type {Phaser.GameObjects.Group}
   */
  const levelComplete = scene.add.group([
    scene.add
      .image(width / 2, height / 2, "bambooFrame")
      .setScale(0.6 * scaleX, 0.4 * scaleX),
    scene.add
      .text(width / 2, 230 * scaleX, "Level Complete!", {
        fontFamily: "Grooving",
        fontSize: "45px",
        color: "#323232",
      })
      .setScale(scaleX)
      .setOrigin(0.5),
    scene.add
      .sprite(width / 2, 300 * scaleX, "coin0")
      .setOrigin(1, 0.5)
      .setScale(0.2 * scaleX),
    scene.add
      .text(width / 2, 300 * scaleX, "+5", {
        fontSize: "45px",
        fontFamily: "Grooving",
        color: "#323232",
      })
      .setScale(scaleX)
      .setOrigin(0, 0.5),
  ]);
  scene.time.addEvent({
    delay: 500,
    callback: () => {
      callbackText();
    },
    callbackScope: scene,
    loop: false,
    repeat: 4,
  });
  scene.time.delayedCall(3000, () => {
    callbackFinal(levelComplete);
  });
};

/**
 * @param {Phaser.GameObjects.Group} levelComplete
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Sprite} chest
 */
export const winFinalDialogue = (
  levelComplete,
  scene,
  chest,
  width,
  height,
  scaleX,
  nextLevel
) => {
  levelComplete.setVisible(false);
  scene.add
    .image(width / 2, height / 2 - 10 * scaleX, "bambooFrame")
    .setScale(0.7 * scaleX, 0.7 * scaleX);
  scene.add
    .text(width / 2, 160 * scaleX, "Congrats!", {
      fontFamily: "Grooving",
      fontSize: "60px",
      color: "#323232",
    })
    .setScale(scaleX)
    .setOrigin(0.5);
  scene.add
    .text(width / 2 - 70 * scaleX, 240 * scaleX, "Open the loot", {
      fontFamily: "Grooving",
      fontSize: "35px",
      color: "#323232",
    })
    .setScale(scaleX)
    .setOrigin(0.5);
  scene.add
    .text(width / 2 - 70 * scaleX, 270 * scaleX, "Crate for 50 coins?", {
      fontFamily: "Grooving",
      fontSize: "35px",
      color: "#323232",
    })
    .setScale(scaleX)
    .setOrigin(0.5);
  chest
    .setPosition(width / 2 + 90 * scaleX, 250 * scaleX)
    .setDepth(1)
    .setVisible(true);
  scene.add
    .text(width / 2 - 70 * scaleX, 330 * scaleX, "Or", {
      fontFamily: "Grooving",
      fontSize: "40px",
      color: "#323232",
    })
    .setScale(scaleX)
    .setOrigin(0.5);
  scene.add
    .text(width / 2 - 90 * scaleX, 380 * scaleX, "Next Level", {
      fontFamily: "Grooving",
      fontSize: "40px",
      color: "#323232",
    })
    .setScale(scaleX)
    .setOrigin(0.5);
  createButton(
    scene,
    width / 2 + 120 * scaleX,
    380 * scaleX,
    "continue",
    0.3 * scaleX,
    () => {
      scene.scene.start(nextLevel);
    }
  );
};
